import { ReactElement } from 'react';

import { PatientConsentDocument } from '@dreryk/egabinet-patient-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { ConsentsAndAuthorizationsDocumentAttachmentsModal } from './ConsentsAndAuthorizationsDocumentAttachmentsModal';

type ConsentsAndAuthorizationsDocumentAttachmentsModalOpenerRenderer = (renderProps: {
   openModal: VoidFunction;
}) => ReactElement;

type ConsentsAndAuthorizationsDocumentAttachmentsModalOpenerProps = {
   readonly name: PatientConsentDocument['name'];
   readonly attachments: PatientConsentDocument['attachments'];
   readonly children: ConsentsAndAuthorizationsDocumentAttachmentsModalOpenerRenderer;
};

export const ConsentsAndAuthorizationsDocumentAttachmentsModalOpener = (
   props: ConsentsAndAuthorizationsDocumentAttachmentsModalOpenerProps
): ReactElement => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <ConsentsAndAuthorizationsDocumentAttachmentsModal
               name={props.name}
               attachments={props.attachments}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
